/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner } from './get-organizations-deals200-response-inner-card-transaction-evidence-list-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsDeals200ResponseInnerIntegratedBy } from './get-organizations-deals200-response-inner-integrated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsDeals200ResponseInnerInvoiceIssuer } from './get-organizations-deals200-response-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsDeals200ResponseInnerJournalEntriesInner } from './get-organizations-deals200-response-inner-journal-entries-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetOrganizationsDeals200ResponseInnerJournalizedBy } from './get-organizations-deals200-response-inner-journalized-by';

/**
 * 
 * @export
 * @interface GetOrganizationsDeals200ResponseInner
 */
export interface GetOrganizationsDeals200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'issuedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'freeeDealId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'freeePartnerId': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'partnerId': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'amountYen': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'visaTransactionReferenceId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'status': GetOrganizationsDeals200ResponseInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'cardHolder': string | null;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerJournalizedBy}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'journalizedBy': GetOrganizationsDeals200ResponseInnerJournalizedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'journalizedAt': string | null;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerIntegratedBy}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'integratedBy': GetOrganizationsDeals200ResponseInnerIntegratedBy | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'integratedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'userAccountGroupName': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'isOnDemand': boolean | null;
    /**
     * 
     * @type {Array<GetOrganizationsDeals200ResponseInnerJournalEntriesInner>}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'journalEntries': Array<GetOrganizationsDeals200ResponseInnerJournalEntriesInner>;
    /**
     * 
     * @type {Array<GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner>}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'cardTransactionEvidenceList': Array<GetOrganizationsDeals200ResponseInnerCardTransactionEvidenceListInner>;
    /**
     * true if the deal has one or more evidences and those all are not qualified, which should be shown as a warning to users.
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'isAllEvidencesNotQualified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'canSync': boolean;
    /**
     * 
     * @type {GetOrganizationsDeals200ResponseInnerInvoiceIssuer}
     * @memberof GetOrganizationsDeals200ResponseInner
     */
    'invoiceIssuer': GetOrganizationsDeals200ResponseInnerInvoiceIssuer | null;
}

export const GetOrganizationsDeals200ResponseInnerStatusEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type GetOrganizationsDeals200ResponseInnerStatusEnum = typeof GetOrganizationsDeals200ResponseInnerStatusEnum[keyof typeof GetOrganizationsDeals200ResponseInnerStatusEnum];


